import { TFullUnlockChargeType } from '../types/TRatesState';

const fullUnlockChargeTypes: readonly TFullUnlockChargeType[] = ['PAY_DIFFERENCE', 'ADDITIONAL_CHARGE'];

export const parseFullUnlockChargeType = (value: string): TFullUnlockChargeType | undefined =>
  fullUnlockChargeTypes.find((chargeType) => chargeType === value);
